export const posterMockData = [
  { 
    label: "Poster Size", 
    val: "A0 Size (Portrait)", 
    sub: "90 cm (width) x 120 cm (height)" 
  },
  { 
    label: "File Format", 
    val: "High-Res PDF", 
    sub: "Maximum file size 20MB, 300 DPI" 
  },
  { 
    label: "Header Details", 
    val: "Title & Authors", 
    sub: "Font size: Title (80pt), Authors (54pt)" 
  },
  { 
    label: "Submission", 
    val: "Digital Upload", 
    sub: "Deadline: May 20th, 2026 via Portal" 
  },
  { 
    label: "Printing", 
    val: "On-Site Display", 
    sub: "Organizers will provide the poster boards" 
  },
  { 
    label: "Presentation", 
    val: "Poster Pitch", 
    sub: "2-minute lightning talk during coffee break" 
  }
];